import { render, staticRenderFns } from "./TrainingCourseCategoriesCrud.vue?vue&type=template&id=74e71b4c&"
import script from "./TrainingCourseCategoriesCrud.vue?vue&type=script&lang=js&"
export * from "./TrainingCourseCategoriesCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports